import { render, staticRenderFns } from "./DowntimeCommentsList.vue?vue&type=template&id=5091f0a6&scoped=true&"
import script from "./DowntimeCommentsList.vue?vue&type=script&lang=js&"
export * from "./DowntimeCommentsList.vue?vue&type=script&lang=js&"
import style0 from "./DowntimeCommentsList.vue?vue&type=style&index=0&id=5091f0a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5091f0a6",
  null
  
)

export default component.exports